import skillsPhotsmain from '../../../assets/skills-icon/skillsPhotsmain.png';
import './Skills.css';
import SkillsItem from './SkillsItem';


const Skills = () => {
const skillss = [
      {

      "id": 1,
      "name1": "WebApplication",
      "img1": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeyIEirsm9ozDvwhP--ldqggqf6Yz-gVBLxg&s",
      "name2": "Mobile App",
      "img2": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjtTrVvTGj9XFzxZQdTaHmNocXygw72C5HJQ&s",
      "name4": "React js & Nodejs",
      "img4": "https://azim-profile.netlify.app/static/media/react.3977ddbe7f665b2c0aee.png",
      "name3": "JavaScript ",
     "img3": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSod7CJvOSEFdtFtmH1pbaPYSW8M4gXMwsmWA&s",
      "name5": "UI Design",
      "img5": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1dU_3RJlKWqAA1ibIfEsXDdmRMGIHZJLBWQ&s",
    
    },
{
  "id": 2,
  "name1": "Prompt Engineering ",
  "img1": "https://images.seeklogo.com/logo-png/46/1/chatgpt-logo-png_seeklogo-465219.png",

  "name2": "agentic AI Automation",
  "img2": "https://raw.githubusercontent.com/sharifulislm/Minas_protfolio/refs/heads/main/src/assets/logo/download%20(3).jfif",

  "name3": "Img/Vid Generator ",
  "img3": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAtQct7BNfjT_A1NIRLg6BVMrT9GBkzgQBPQ&s",

  "name4": "Canva & Ps",
  "img4": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9NGsrHYW5QyW57-Rr7kIrJPV2vbnnyevVyQ&s",

  "name5": "Open AI ",
  "img5": "https://images.seeklogo.com/logo-png/46/1/chatgpt-logo-png_seeklogo-465219.png",
}
,
{
  "id": 3,
  "name1": "Deployment & Hosting",
  "img1": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMbsiUl1OIAieg4-SY9qh4jFKwj5rV1QAlMg&s",

  "name2": "Usr Authentication ",
  "img2": "https://github.com/sharifulislm/Minas_protfolio/blob/main/src/assets/logo/download%20(4).png?raw=true",

  "name3": "API Integration/Security",
  "img3": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0CiQhQoS9s991HHae9eb74TxiRwiG0m-m0g&s",

    "name4": "UI Design",
  "img4": "https://raw.githubusercontent.com/sharifulislm/Minas_protfolio/refs/heads/main/src/assets/logo/download%20(2).jfif",

  "name5": "Firebase",
  "img5": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7iaSsAwCkQDsgn_WxZhC5OW-apJBRVP3wHw&s"
},
    // {

    //   "id": 1,
    //   "name1": "Html 5",
    //   "img1": "https://azim-profile.netlify.app/static/media/html.508b267241d25229c7a8.png",
    //   "name2": "Bootstrap",
    //   "img2": "https://azim-profile.netlify.app/static/media/bootstrap.eb4bbd494473eb1d52ca.png",
    //   "name3": "JavaScript",
    //   "img3": "https://azim-profile.netlify.app/static/media/html.508b267241d25229c7a8.png",
    //   "name4": "React js",
    //   "img4": "https://azim-profile.netlify.app/static/media/react.3977ddbe7f665b2c0aee.png",
    //   "name5": "React Bootstrap",
    //   "img5": "https://azim-profile.netlify.app/static/media/rb.c583c04000d30b085623.png",
    // },
    // {
    //   "id": 2,
    //   "name1": "CSS3",
    //   "img1": "https://azim-profile.netlify.app/static/media/css.11256a5481cde3058426.png",
    //   "name2": "Tailwind CSS",
    //   "img2": "https://azim-profile.netlify.app/static/media/bootstrap.eb4bbd494473eb1d52ca.png",
    //   "name3": "ES6",
    //   "img3": "data:image/png;base64,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",
    //   "name4": "React-router",
    //   "img4": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4r4CDeALv258ZKvQcwRzKKHoSasiKfgseNw&usqp=CAU",
    //   "name5": "React Query",
    //   "img5": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSD6Sz1XSP2ATC4Lg-T0t4XOX0OGv6w8q936A&usqp=CAU",

    // },
    // {
    //   "id": 3,
    //   "name1": "Node.js",
    //   "img1": "https://azim-profile.netlify.app/static/media/node.593013e5018ed329d3f4.png",
    //   "name2": "MongoDB",
    //   "img2": "https://azim-profile.netlify.app/static/media/mongoDB.2341c8f8e37584b40f41.png",
    //   "name3": "Express.js",
    //   "img3": "https://azim-profile.netlify.app/static/media/express.213bce8758c3b770c1b2.png",
    //   "name4": "Firebase",
    //   "img4": "https://azim-profile.netlify.app/static/media/firebase.d19d58ab5b56ed09d654.png",
    //   "name5": "React Hook",
    //   "img5": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRC5RY46Qm-MPuv62Xv5asvMF03s1d_ep1mIDPa-8Aaw5el4TJ6wW_RBRuQN3mdO__21Ik&usqp=CAU",

    // },
    // {
    //   "id": 4,
    //   "name1": "Vs Studio Code",
    //   "img1": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRp1bFwS4rOJgaNvb1xLMNpvRHJK6WEkgbV9A&usqp=CAU",
    //   "name2": "Chrome Tools",
    //   "img2": "https://github.com/sharifulislm/Protfolio-/blob/main/skills-icon/skills-icon%20(1).png?raw=true",
    //   "name3": "Heroku",
    //   "img3": "https://camo.githubusercontent.com/8274f7df75bac91a2ac39f668c78df0817428ec3e465c7d1b899c664a60f701e/68747470733a2f2f656e637279707465642d74626e302e677374617469632e636f6d2f696d616765733f713d74626e3a414e643947635456736f7838767542314e73596d3969454f455f2d776473734f4b6d56654d765167387726757371703d434155",
    //   "name4": "Stripe",
    //   "img4": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsr7nmbrdidXzM6O88ufEGcoHt-ol51Zzzow&usqp=CAU",
    //   "name5": "DaisyUI",
    //   "img5": "https://azim-profile.netlify.app/static/media/dui.f3c5220288ff2b6eedcd.png",
    // }


  ]
  


    return (
        <div className=' skills p-5 mt-9'>
        <div id='Skills'><h1 style={{color:"#19AB78"}} className='text-3xl mt-5 m-auto text-center'>My Skills</h1>
            <div style={{backgroundColor:"#19AB78"}} className='m-auto w-40 mb-5 mt-1 h-1 '></div>
            </div>
       <div  className='mb-5 grid grid-cols-1 lg:grid-cols-4  mt-7 gap-1  sm:mb-20 '>

      <div>
      <div 
           data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="3000"
             className='flex items-end md:order-first order-last '><img className='hidden sm:block' src={skillsPhotsmain} alt="" /> </div>
      </div>

            {
                skillss.map(skills=><SkillsItem skills={skills} key={skills.id}></SkillsItem> )
            }
        </div>
        {/* <h1 className='text-xl justify-start align-text-lift'>- Tools </h1>
     <div className='flex  justify-center'>
      <TolsSkills></TolsSkills>
     </div> */}
        </div>
    );
};


export default Skills;